<template>
  <v-btn
    class="rounded"
    outlined
    small
    text
    icon
    :color="color"
    v-bind="$attrs"
    :style="{
      backgroundColor: $vuetify.theme.currentTheme.secondarySheet,
    }"
    @click="$emit('click', $event)"
  >
    <v-icon small>
      {{ icon }}
    </v-icon>
  </v-btn>
</template>

<script>
export default {
  inheritAttrs: false, // Prevent attrs from going to root
  props: {
    icon: {
      type: String,
      default: 'mdi-undo'
    },
    color: {
      type: String,
      default: 'review'
    }
  }
}
</script>